module.exports = __webpack_public_path__ + "media/application/images/external-services/limited-run-logo-921190802849fd2bc95f645d71bf06e8.svg";